import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=671a42dd&scoped=true&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=671a42dd&prod&lang=scss&scoped=true&"
import style1 from "./HomeView.vue?vue&type=style&index=1&id=671a42dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a42dd",
  null
  
)

export default component.exports